module.exports = __webpack_public_path__ + "img/time.0ad8f5b7.svg";